var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.933,
    height: 34.984,
    viewBox: "0 0 34.933 34.984",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "phone-call",
    transform: "translate(-0.344 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_14696",
    "data-name": "Group 14696",
    transform: "translate(0.344 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33864",
    "data-name": "Path 33864",
    d: "M27.967,47.054a3.441,3.441,0,0,0-2.5-1.144,3.558,3.558,0,0,0-2.525,1.137l-2.333,2.326c-.192-.1-.384-.2-.569-.3-.266-.133-.517-.258-.731-.391a25.359,25.359,0,0,1-6.077-5.538A14.961,14.961,0,0,1,11.243,40c.605-.554,1.167-1.13,1.713-1.683.207-.207.413-.421.62-.628a3.388,3.388,0,0,0,0-5.109l-2.016-2.016c-.229-.229-.465-.465-.687-.7-.443-.458-.908-.93-1.388-1.373a3.5,3.5,0,0,0-2.473-1.085A3.617,3.617,0,0,0,4.5,28.491l-.015.015-2.51,2.533a5.4,5.4,0,0,0-1.6,3.433,12.943,12.943,0,0,0,.945,5.479,31.791,31.791,0,0,0,5.648,9.421,34.746,34.746,0,0,0,11.57,9.06,18.027,18.027,0,0,0,6.5,1.92c.155.007.317.015.465.015a5.564,5.564,0,0,0,4.26-1.831c.007-.015.022-.022.03-.037a16.786,16.786,0,0,1,1.292-1.336c.317-.3.642-.62.96-.952a3.683,3.683,0,0,0,1.115-2.555,3.548,3.548,0,0,0-1.137-2.533Zm2.643,7.775c-.007,0-.007.007,0,0-.288.31-.583.591-.9.9a19.416,19.416,0,0,0-1.425,1.477,3.559,3.559,0,0,1-2.776,1.174c-.111,0-.229,0-.34-.007a16.014,16.014,0,0,1-5.759-1.728,32.8,32.8,0,0,1-10.9-8.535A29.976,29.976,0,0,1,3.2,39.257a10.542,10.542,0,0,1-.827-4.622,3.389,3.389,0,0,1,1.019-2.193l2.518-2.518A1.678,1.678,0,0,1,7.027,29.4a1.579,1.579,0,0,1,1.078.517l.022.022c.45.421.879.856,1.329,1.322.229.236.465.473.7.716l2.016,2.016a1.409,1.409,0,0,1,0,2.289c-.214.214-.421.428-.635.635-.62.635-1.211,1.226-1.853,1.8-.015.015-.03.022-.037.037a1.506,1.506,0,0,0-.384,1.676l.022.066a16.183,16.183,0,0,0,2.385,3.891l.007.007a27.1,27.1,0,0,0,6.557,5.966,10.083,10.083,0,0,0,.908.495c.266.133.517.258.731.391.03.015.059.037.089.052a1.6,1.6,0,0,0,.731.185,1.579,1.579,0,0,0,1.122-.509l2.525-2.525a1.67,1.67,0,0,1,1.115-.554,1.5,1.5,0,0,1,1.063.539l.015.015L30.6,52.517A1.46,1.46,0,0,1,30.611,54.829Z",
    transform: "translate(-0.344 -25.382)",
    fill: "#ff5e15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33865",
    "data-name": "Path 33865",
    d: "M245.764,87.9a9.5,9.5,0,0,1,7.738,7.738.991.991,0,0,0,.982.827,1.32,1.32,0,0,0,.17-.015,1,1,0,0,0,.82-1.152,11.49,11.49,0,0,0-9.362-9.362,1,1,0,0,0-1.152.812A.986.986,0,0,0,245.764,87.9Z",
    transform: "translate(-226.884 -79.581)",
    fill: "#ff5e15"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33866",
    "data-name": "Path 33866",
    d: "M265.35,15.432A18.92,18.92,0,0,0,249.933.015a1,1,0,1,0-.325,1.964,16.9,16.9,0,0,1,13.778,13.778.991.991,0,0,0,.982.827,1.319,1.319,0,0,0,.17-.015A.978.978,0,0,0,265.35,15.432Z",
    transform: "translate(-230.432 0)",
    fill: "#ff5e15"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.28bc8bb4b68a70ea191f964781052c70.svg";
export { ForwardRef as ReactComponent };